// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bfk_a bih_tr","StrollerBoxWidget__imageCounselling":"bfk_b bih_kg"};